import { useReducer } from "react";
import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

import {
  filterDateRangeReducer,
  filterDateRangeInitialValue
} from "reducers/filterDateRange";
import { useMeta } from "hooks";

export interface useNewsArgs {
  currentPage: number;
}

export const useNews = ({ currentPage }: useNewsArgs) => {
  const [{ filterDates, formatedFilterDates }, setFiltersDateRange] =
    useReducer(filterDateRangeReducer, filterDateRangeInitialValue);
  const { setMetaTags } = useMeta();

  const { language } = useSelector((state: RootState) => state.global);

  const PAGE_SIZE = 12;

  const { data: news } = useQuery(
    [language, currentPage, formatedFilterDates, "posts"],
    () =>
      publicRequest({
        url: `/api/posts/${language}?page=${currentPage}&per_page=${PAGE_SIZE}&start_date=${formatedFilterDates?.startDate}&end_date=${formatedFilterDates?.endDate}`,
        method: "get"
      }),
    {
      onSuccess: (res) => {
        setMetaTags(res?.data?.meta);
      }
    }
  );

  return {
    news: news?.data?.data,
    maxPages: news?.data?.max_pages,
    PAGE_SIZE,
    filterDates,
    setFiltersDateRange
  };
};
